var klevu_uc = {
  showLandingPageData: function (product) {
    var toReturn = '',
      additionalParams = '',
      keywords = document.getElementById('searchedKeyword').value,
      trackingEventHtml = '',
      additionalFlags = product.additionalDataToReturn
        ? JSON.parse(product.additionalDataToReturn)
        : false

    product = klevu_productCustomizations(product)
    product.additionalFlags = additionalFlags

    if (product.productImage.trim().length === 0) {
      product.productImage = klevu_userOptions.noImageUrl
    }

    trackingParams =
      '{' +
      'data: {' +
      "code: '" +
      escape(product.productCode) +
      "'," +
      "url: '" +
      escape(product.productUrl) +
      "'," +
      "name: '" +
      escape(product.productName) +
      "'," +
      "salePrice: '" +
      escape(product.salePrice) +
      "'," +
      "rating: '" +
      escape(product.rating) +
      "'," +
      'position: ' +
      product.productPosition +
      ',' +
      "category: '" +
      escape(product.category) +
      "'," +
      "sku: '" +
      escape(product.sku) +
      "'" +
      '},' +
      'apiKey: null,' +
      "keywordsLP: '" +
      escape(keywords) +
      "'" +
      '}'

    if (klevu_commons.isMobileDevice()) {
      trackingEventHtml =
        ' onclick="return klevu_analytics.trackClickedProduct(event, ' +
        trackingParams +
        ');" >'
    } else {
      trackingEventHtml =
        ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' +
        trackingParams +
        ');" onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
        trackingParams +
        ', klevu_analytics.trackClickedProduct);" ' +
        additionalParams +
        '>'
    }

    try {
      toReturn += '<li class="clc-List_Item">'
      toReturn += '<article class="prd-Card prd-Card-klevu">'
      toReturn += renderImage(product)
      toReturn += renderContent(product)
      toReturn += renderActions(product)
      toReturn += renderLink(product, trackingEventHtml)
      toReturn += '</article>'
      toReturn += '</li>'
    } catch (e) {
      console.error(e)
    }

    return toReturn
  }
}

function renderImage (product) {
  var toReturn = '<div class="prd-Card_ImageContainer">'

  toReturn += '<div class="rsp-Image">'
  toReturn += '<img class="rsp-Image_Image" src="' + product.imageUrl + '" />'
  toReturn += '</div>'

  toReturn += renderTags(product)

  toReturn += '</div>'

  return toReturn

  function renderTags (product) {
    var lineItems = window.store.getters['pushCart/GET_LINE_ITEMS']
    var isInCart = lineItems.some(function (item) {
      return item.product_id === parseInt(product.itemGroupId, 10)
    })

    try {
      product.salePrice = (+product.salePrice).toFixed(1)
      product.productPrice = (+product.productPrice).toFixed(1)
    } catch (error) {
      console.log(error)
    }

    var isOnSale = product.salePrice !== product.productPrice
    var tax = window.theme.showVat ? 1.2 : 1
    var stickerTag =
      'tags' in product
        ? product.tags.split(', ').reduce(function (acc, tag) {
            if (tag.indexOf('sticker:') >= 0) {
              acc = tag.split(':')[1].trim()
            }

            return acc
          }, '')
        : ''

    var toReturn = '<div class="prd-Card_Tags">'

    if (isInCart) {
      toReturn += '<span class="prd-Card_Tag prd-Card_Tag-alert">'
      toReturn += window.theme.strings.isInCart
      toReturn += '</span>'
    } else if (isOnSale) {
      toReturn += '<span class="prd-Card_Tag prd-Card_Tag-sale">'
      toReturn += '<span class="prd-Card_TagHeader">'
      toReturn += '<span class="prd-Card_TagText">'
      toReturn += 'Was:'
      toReturn +=
        '<span>' +
        window.formatMoney(parseFloat(product.productPrice) * 100 * tax) +
        '</span>'
      toReturn += '</span>'
      toReturn += '<span class="prd-Card_TagText">'
      toReturn += 'Save:'
      toReturn +=
        '<span>' +
        window.formatMoney(
          (parseFloat(product.productPrice) * 100 -
            parseFloat(product.salePrice) * 100) *
            tax
        ) +
        '</span>'
      toReturn += '</span>'
      toReturn += '</span>'
      toReturn +=
        '<span class="prd-Card_TagText">' +
        window.theme.strings.onSale +
        '</span>'
      toReturn += '</span>'
    } else if (stickerTag !== '') {
      toReturn += '<span class="prd-Card_Tag">' + stickerTag + '</span>'
    }

    toReturn += '</div>'

    return toReturn
  }
}

function renderContent (product) {
  var toReturn = '<div class="prd-Card_Content">'
  toReturn += renderSku(product.sku)
  toReturn += renderTitle(product.name)
  toReturn += renderPrices(product)
  toReturn += '</div>'

  return toReturn

  function renderSku (sku) {
    return '<p class="prd-Card_Sku">' + sku + '</p>'
  }

  function renderTitle (title) {
    return '<h3 class="prd-Card_Title">' + title + '</h3>'
  }

  function renderPrices (product) {
    var toReturn = '<div class="prd-Card_Prices">'
    toReturn += renderBasePrice(product)
    toReturn += renderAdditionalPrices(product)
    toReturn += '<p class="prd-Card_PricesDisclaimer">Price Excludes VAT</p>'
    toReturn += '</div>'

    return toReturn
  }

  function renderBasePrice (product) {
    var price = window.theme.showVat
      ? basePrice(product) * 1.2
      : basePrice(product)

    var toReturn = '<div class="prd-Card_Price">'
    toReturn +=
      '<p class="prd-Card_Label">' + window.theme.strings.priceEach + '</p>'
    toReturn +=
      '<p class="prd-Card_Value">' + window.formatMoney(price) + '</p>'
    toReturn += '</div>'

    return toReturn
  }

  function renderAdditionalPrices (product) {
    var toReturn = ''
    var showWholesalePrices = showWholesaleAdditionalPrice(product)
    var fields = getMetafieldPrices(product)
    var tax = window.theme.showVat ? 1.2 : 1

    if (!product.compare_at_price > product.price) {
      toReturn += '<div class="prd-Card_Price">'
      toReturn += '<p class="prd-Card_Label">Buy 10+</p>'
      toReturn +=
        '<p class="prd-Card_Value">' +
        window.formatMoney(product.price * 100 * 0.9 * tax) +
        '</p>'
      toReturn += '</div>'
    }

    if (showWholesalePrices) {
      toReturn += '<div class="prd-Card_Price">'
      toReturn +=
        '<p class="prd-Card_Label">Buy ' + fields.wholesale[1].label + '+</p>'
      toReturn +=
        '<p class="prd-Card_Value">' +
        window.formatMoney(fields.wholesale[1].price * tax) +
        '</p>'
      toReturn += '</div>'

      return toReturn
    } else if (!showWholesalePrices && hasRegularMetafields(product)) {
      var label = fields.regular[0].label.match(/\d+/)

      toReturn += '<div class="prd-Card_Price">'
      toReturn += '<p class="prd-Card_Label">Buy ' + label + '+</p>'
      toReturn +=
        '<p class="prd-Card_Value">' +
        window.formatMoney(fields.regular[0].price * tax) +
        '</p>'
      toReturn += '</div>'
    }

    return toReturn
  }
}

function renderActions (product) {
  var toReturn = ''

  if (isOutOfStockProduct(product)) {
    toReturn += '<div class="prd-Card_Form">'
    toReturn +=
      '<a href="' +
      product.url +
      '" class="prd-Card_Button prd-Card_Button-soldOut btn-Dark btn-Small" disabled>'
    toReturn +=
      '<span class="btn-Text">' + window.theme.strings.soldOut + '</span>'
    toReturn += '</a>'
    toReturn += '</div>'

    return toReturn
  } else if (isDownloadableProduct(product)) {
    toReturn += '<div class="prd-Card_Form">'
    toReturn +=
      '<a href="' +
      product.url +
      '" class="prd-Card_Button btn-Dark btn-Small">'
    toReturn +=
      '<span class="btn-Text">' + window.theme.strings.download + '</span>'
    toReturn += '</a>'
    toReturn += '</div>'

    return toReturn
  } else if (isPersonalisableProduct(product)) {
    toReturn += '<div class="prd-Card_Form">'
    toReturn +=
      '<a href="' +
      product.url +
      '" class="prd-Card_Button btn-Dark btn-Small">'
    toReturn +=
      '<span class="btn-Text">' + window.theme.strings.personalise + '</span>'
    toReturn += '</a>'
    toReturn += '</div>'

    return toReturn
  } else if (parseInt(product.totalVariants, 10) > 0) {
    toReturn += '<div class="prd-Card_Form">'
    toReturn +=
      '<a href="' +
      product.url +
      '" class="prd-Card_Button btn-Dark btn-Small">'
    toReturn +=
      '<span class="btn-Text">' + window.theme.strings.pleaseChoose + '</span>'
    toReturn += '</a>'
    toReturn += '</div>'

    return toReturn
  }

  toReturn +=
    '<form class="prd-Card_Form js-AddToCart" action="/cart/add" method="post" enctype="multipart/form-data">'
  toReturn += '<input type="hidden" name="id" value="' + product.id + '" />'

  toReturn += renderMetafieldFormInputs(product)

  toReturn +=
    '<input type="number" name="quantity" value="1" class="prd-Card_Input" />'
  toReturn +=
    '<button type="submit" class="prd-Card_Button btn-Dark btn-Small">' +
    window.theme.strings.addToCart +
    '</button>'
  toReturn += '</form>'

  return toReturn
}

function renderMetafieldFormInputs (product) {
  var metafields = getMetafieldPrices(product)

  return Object.keys(metafields)
    .map(function (key) {
      return metafields[key]
        .map(function (metafield) {
          return (
            '<input type="hidden" name="properties[' +
            metafield.label +
            ']" value="' +
            metafield.price +
            '" />'
          )
        })
        .join('')
    })
    .join('')
}

function renderLink (product, trackingCode) {
  return (
    '<a class="prd-Card_FauxLink" href="' +
    product.url +
    '"' +
    trackingCode +
    '</a>'
  )
}

function basePrice (product) {
  return showWholesalePrice(product)
    ? getMetafieldPrices(product).wholesale[0].price
    : getProductPrice(product)
}

function getProductPrice (product) {
  return parseFloat(product.salePrice) * 100
}

function showWholesalePrice (product) {
  return (
    window.theme.customer.isWholesale &&
    hasWholesaleMetafields(product) &&
    getMetafieldPrices(product).wholesale[0].label === '_wholesale-1-price'
  )
}

function showWholesaleAdditionalPrice (product) {
  var hasMoreThanOneWholesalePrice =
    getMetafieldPrices(product).wholesale.length > 1

  return showWholesalePrice(product) && hasMoreThanOneWholesalePrice
}

function hasWholesaleMetafields (product) {
  return product.additionalData.indexOf('_wholesale') > 0
}

function hasRegularMetafields (product) {
  return getMetafieldPrices(product).regular.length > 0
}

function getMetafieldPrices (product) {
  return product.additionalData.split(';').reduce(
    function (acc, item) {
      if (item === '') return acc

      var label = item.split(':')[0].replace(' ', '-')
      var price = item.split(':')[1].includes('.')
        ? parseFloat(item.split(':')[1]) * 100
        : parseFloat(item.split(':')[1])
      var value = {
        label: label,
        price: price
      }

      if (label.startsWith('_wholesale')) {
        acc.wholesale.push(value)
      } else {
        acc.regular.push(value)
      }

      return acc
    },
    { regular: [], wholesale: [] }
  )
}

function isPersonalisableProduct (product) {
  return 'tags' in product && product.tags.indexOf('personalisable') > 0
}

function isDownloadableProduct (product) {
  return product.type === 'Document'
}

function isOutOfStockProduct (product) {
  // Klevu records carry inStock: 'yes' / 'no'. Default to in-stock when absent
  // so a missing field can never hide a buyable product.
  return String(product.inStock).toLowerCase() === 'no'
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0

    return this.substr(position, searchString.length) === searchString
  }
}

function klevu_uc_productCustomizations(product) {
  if (typeof product.additionalData === 'undefined') {
    product.additionalData = '';
  }
  return product;
}

